import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Popup from "../component/section/popup";
import CreateVolunteer from "./createVolunteer";
import { LIST_ALL_VOLUNTEERS } from "../API_LIST";
import matrimonyInstance from "../utils/axios";
import VolunteerCard from "../component/section/volunteerCard";
import PaginationComponent from "../component/section/PaginatedItems";

export default function AdminDashboard() {
	const navigate = useNavigate();
	const [modalIsOpen, setIsOpen] = useState(false);
	const [volunteersList, setVolunteersList] = useState([]);

	const [totalCount, setTotalCount] = useState(9);

	const [pageNumber, setPageNumber] = useState(1);

	const [countPerPage, setCountPerPage] = useState(9);
	function closeModal() {
		setIsOpen(false);
	}

	useEffect(() => {
		getData();
	}, []);
	function onPageChanged(key, value) {
		if (key == "pageNumber") {
			setPageNumber(value);
			getData(9, value);
		} else if (key == "countPerPage") {
			setCountPerPage(value);
			getData(value, 1);
		}
	}
	async function getData(customCountPerPage, customPageNumber) {
		matrimonyInstance.get(LIST_ALL_VOLUNTEERS).then((response) => {
			let objectIs = response.data.volunteers;
			setVolunteersList(objectIs);
		});
	}

	return (
		<React.Fragment>
			<div id="dashboard" className="">
				<div className="d-flex justify-content-between align-items-center pt-25 mr-30 ml-30 mb-20">
					<h5>Volunteer List</h5>
					<span onClick={() => setIsOpen(true)} className="cursor-pointer">
						<img
							src="../assets/images/bat-img/add-profile.svg"
							className="add-profile mr-10"
						/>
						Create Volunteer
					</span>
				</div>
				<div className="d-flex justify-content-center pb-30">
					<div className="profile-card-list">
						{volunteersList.map((item, index) => (
							<VolunteerCard data={item} key={index} />
						))}
					</div>
				</div>
				<PaginationComponent
					totalCount={totalCount}
					onValueChanged={onPageChanged}
					pageNumber={pageNumber}
					countPerPage={countPerPage}
				/>
			</div>
			<Popup
				modalIsOpen={modalIsOpen}
				closeModal={closeModal}
				html={<CreateVolunteer closeModal={closeModal} />}
			/>
		</React.Fragment>
	);
}
